import React from 'react'
import PropTypes from 'prop-types'
import {defineMessage, useIntl} from 'react-intl'
import {SimpleGrid, Stack} from '@salesforce/retail-react-app/app/components/shared/ui'
import useProfileFields from './useProfileFields'
import Field from '../../../../components/field'
import {formStyles} from './styles'
import {pxToRem} from '../../../../utills/pxToRem'

const ProfileFields = ({form, prefix = ''}) => {
    const fields = useProfileFields({form, prefix})
    const intl = useIntl()
    const formTitleAriaLabel = defineMessage({
        defaultMessage: 'Profile Form',
        id: 'profile_fields.label.profile_form'
    })

    return (
        <Stack aria-label={intl.formatMessage(formTitleAriaLabel)} sx={formStyles}>
            <SimpleGrid columns={[1, 1, 1, 2]} spacing={0} gap={{base: 0, lg: pxToRem(10)}}>
                <Field {...fields.firstName} />
                <Field {...fields.lastName} />
            </SimpleGrid>
            <Field {...fields.phone} type="tel" autoComplete="off" />
            <Field {...fields.email} border={'none'} disabled={true} />
            <Field {...fields.birthday} />
        </Stack>
    )
}

ProfileFields.propTypes = {
    form: PropTypes.object.isRequired,
    prefix: PropTypes.string
}

export default ProfileFields
